var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C16.9987 12.2553 16.9406 12.5071 16.8299 12.7372C16.7192 12.9672 16.5587 13.1697 16.36 13.33L11.26 17.54C10.953 17.786 10.583 17.9408 10.1923 17.9868C9.80153 18.0328 9.40574 17.9681 9.05 17.8C8.74083 17.6637 8.47741 17.4413 8.29122 17.1594C8.10503 16.8775 8.00393 16.5479 8 16.21L8 7.79002C8.00393 7.45217 8.10503 7.12259 8.29122 6.84064C8.47741 6.5587 8.74083 6.3363 9.05 6.20002C9.40574 6.03199 9.80153 5.96727 10.1923 6.01324C10.583 6.05921 10.953 6.21402 11.26 6.46002L16.36 10.67C16.5587 10.8303 16.7192 11.0328 16.8299 11.2629C16.9406 11.4929 16.9987 11.7447 17 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d0b540a91a2db7a61caf0d570e3078a9.svg";
export { ForwardRef as ReactComponent };